import React from "react";
import { Field } from "./_helpers";

/** Scope filter bar (Branch / Class / Section). */
export default function ScopeFilterBar({
  branchId, branches, onBranchChange,
  classId, classes, onClassChange,
  sectionId, sections, onSectionChange,
  schoolYear,
}) {
  return (
    <section className="bg-white rounded-2xl border border-brand-purple/10 shadow-sm p-3 sm:p-4 mb-4" data-testid="gs-filters">
      <div className="grid sm:grid-cols-3 gap-3">
        <Field label="BRANCH">
          <select value={branchId || ""} onChange={(e) => onBranchChange(e.target.value)} className="gs-select" data-testid="gs-branch">
            {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        </Field>
        <Field label="CLASS / LEVEL">
          <select value={classId} onChange={(e) => onClassChange(e.target.value)} className="gs-select" data-testid="gs-class">
            <option value="">All levels (school-wide)</option>
            {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </Field>
        <Field label="SECTION">
          <select value={sectionId} onChange={(e) => onSectionChange(e.target.value)} className="gs-select" data-testid="gs-section" disabled={!classId}>
            <option value="">All sections</option>
            {sections.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </Field>
      </div>
      {schoolYear && (
        <p className="mt-3 text-xs text-brand-inkMuted">
          Current School Year: <span className="font-heading text-foreground">{schoolYear.label || `${schoolYear.start_year}-${schoolYear.end_year}`}</span>
        </p>
      )}
    </section>
  );
}
